import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import logoUrl from '../assets/zurian-logo.svg';

const Header = ({ onInnerCircleClick }) => {
  const [isAtTop, setIsAtTop] = useState(true);
  const [isCompact, setIsCompact] = useState(false);
  const [showExplore, setShowExplore] = useState(false);
  const lastScrollY = React.useRef(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      // Check if at the very top for background style
      setIsAtTop(currentScrollY <= 20);

      // Check scroll direction for compact mode
      if (currentScrollY > lastScrollY.current && currentScrollY > 20) {
        // Scrolling DOWN and not at top -> Compact
        setIsCompact(true);
      } else {
        // Scrolling UP or at top -> Normal Size
        setIsCompact(false);
      }

      // Navbar button transitions from "KNOW MORE" to "EXPLORE COLLECTION" only when:
      // 1) The user has significantly scrolled (>= 350px)
      // 2) AND the top of the page is further away than the email section of the page (or on pages without email section, past 400px)
      const MIN_SCROLL_PIXELS = 350;
      const emailSection = document.getElementById('email-capture');
      if (emailSection) {
        const emailTop = emailSection.getBoundingClientRect().top + currentScrollY;
        const distFromTop = currentScrollY;
        const distToEmail = Math.abs(emailTop - currentScrollY);
        setShowExplore(distFromTop > distToEmail && currentScrollY >= MIN_SCROLL_PIXELS);
      } else {
        setShowExplore(currentScrollY >= 400);
      }

      lastScrollY.current = currentScrollY;
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      style={{ top: 'var(--banner-h, 0px)' }}
      className={`fixed left-0 right-0 z-50 transition-all duration-300 paper-texture bg-primary-beige/85 ${!isAtTop ? 'shadow-md backdrop-blur-md' : 'backdrop-blur-sm'}`
      }>

      {/* Paper texture overlay */}
      <div
        className="absolute inset-0 bg-primary-beige/30" />


      <div className={`relative max-w-7xl mx-auto px-4 md:px-12 transition-all duration-500 flex items-center justify-center ${isCompact ? 'py-2 md:py-3' : 'py-4 md:py-5'}`}>
        {/* Centered Logo */}
        <Link to="/" className="flex items-center justify-center">
          <img
            src={logoUrl}
            alt="ZURIAN"
            className={`w-auto transition-all duration-500 ${isCompact ? 'h-6 md:h-8' : 'h-7 md:h-10'}`} />
        </Link>

        {/* CTA Button: KNOW MORE when near top, EXPLORE COLLECTION when scrolled past midpoint closer to email section */}
        {!showExplore ? (
          <button
            onClick={onInnerCircleClick}
            className={`btn-pill text-[10px] sm:text-xs md:text-sm px-3.5 sm:px-4 md:px-6 font-thin absolute right-4 md:right-12 transition-all duration-500 ${isCompact ? 'py-1.5 md:py-2' : 'py-2 sm:py-2 md:py-2.5'}`}>
            KNOW MORE
          </button>
        ) : (
          <a
            href="https://me.zurian.co.in"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Explore Collection (opens in a new tab)"
            className={`btn-pill text-[10px] sm:text-xs md:text-sm px-3.5 sm:px-4 md:px-6 font-thin absolute right-4 md:right-12 transition-all duration-500 inline-flex items-center gap-1.5 ${isCompact ? 'py-1.5 md:py-2' : 'py-2 sm:py-2 md:py-2.5'}`}>
            <span className="sm:hidden">EXPLORE</span>
            <span className="hidden sm:inline">EXPLORE COLLECTION</span>
            <span aria-hidden="true">&rarr;</span>
          </a>
        )}
      </div>
    </header>
  );
};

export default Header;
